let env = process.env.REACT_APP_ENVIRONMENT;

let url = ""
console.log("ENV = " + env)
if (env === "hml") {
    console.log('Homologação')
    url = "https://hml-api.telemetry.com.br";
} else if (env === "prd") {
    console.log('Produção')
    url = "https://api.telemetry.com.br";
} else {
    console.log('Local')
    url = "http://localhost:8080";

}
console.log("URL = " + url)
module.exports = url;